module.exports = __webpack_public_path__ + "static/media/chocolate.2b8162de.gif";